import React from 'react';

const COLORS = {
  cyan:  { dot: '#00C2FF', ring: 'rgba(0,194,255,0.4)' },
  green: { dot: '#4ADE80', ring: 'rgba(74,222,128,0.4)' },
  red:   { dot: '#F87171', ring: 'rgba(248,113,113,0.4)' },
  amber: { dot: '#FBBF24', ring: 'rgba(251,191,36,0.4)' },
};

export default function PulseDot({ variant = 'cyan', size = 8 }) {
  const colors = COLORS[variant] || COLORS.cyan;
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: size, height: size }}>
      <span style={{
        position: 'absolute',
        width: size,
        height: size,
        borderRadius: '50%',
        background: colors.ring,
        animation: 'ping 1.5s cubic-bezier(0,0,0.2,1) infinite',
      }} />
      <span style={{
        position: 'relative',
        width: size * 0.6,
        height: size * 0.6,
        borderRadius: '50%',
        background: colors.dot,
        boxShadow: `0 0 6px ${colors.dot}`,
      }} />
    </span>
  );
}
